import { useTranslation } from "react-i18next";
import { getPhaseClass } from "./parse";

interface PhaseBadgeProps {
  value: string;
}

export function PhaseBadge({ value }: PhaseBadgeProps) {
  const { t } = useTranslation();
  const phaseClass = getPhaseClass(value);

  // Normalize to i18n key format: "laga kraft" → "laga kraft", "samråd" → keep as-is
  const key = value.toLowerCase().trim();
  const i18nKey = `phases.${key}`;
  const translated = t(i18nKey, { defaultValue: "" });

  // Use translated label if available, otherwise raw value
  const displayText = translated || value;

  if (!phaseClass) {
    return <span className="cx-phase-badge">{displayText}</span>;
  }
  return <span className={`cx-phase-badge cx-phase-badge--${phaseClass}`}>{displayText}</span>;
}
